import { z } from 'zod';
import { bloodPressureValidation } from './shared/blood-pressure-validation';
//chore: to match util refactor
const sectionHasValue = (data) => {
    return Object.keys(data).some((prop) => {
        const value = data[prop];
        if ((Array.isArray(value) && !!value?.length) || (!Array.isArray(value) && !!value)) {
            return true;
        }
        return false;
    });
};
export const hhaVisitValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        General: z.object({
            precautions: z.array(z.string()).optional(),
        }),
        Vitals: z.object({
            vitals: z
                .object({
                notCheckedVitals: z.boolean().optional(),
                weight: z.string().optional(),
                height: z.string().optional(),
                temp: z.string().optional(),
                via: z.string().optional(),
            })
                .refine((data) => sectionHasValue(data), {
                message: 'Mark as Not Captured if none applies',
                path: [],
            }),
            o2: z
                .object({
                notCheckedO2: z.boolean().optional(),
                o2Sat: z.string().optional(),
                flow: z.string().optional(),
                inr: z.string().optional(),
                usedO2: z.string().optional(),
                o2Other: z.string().optional(),
            })
                .refine((data) => sectionHasValue(data), {
                message: 'Mark as Not Captured if none applies',
                path: [],
            }),
            pulseRespiration: z
                .object({
                notCheckedPulse: z.boolean().optional(),
                pulse: z.string().optional(),
                aplical: z.string().optional(),
                pulseRegular: z.string().optional(),
                respiration: z.string().optional(),
                respirationRegular: z.string().optional(),
            })
                .refine((data) => sectionHasValue(data), {
                message: 'Mark as Not Captured if none applies',
                path: [],
            }),
            bloodSugar: z
                .object({
                notCheckedBloodSugar: z.boolean().optional(),
                am: z.string().optional(),
                pm: z.string().optional(),
                noon: z.string().optional(),
                hs: z.string().optional(),
            })
                .refine((data) => sectionHasValue(data), {
                message: 'Mark as Not Captured if none applies',
                path: [],
            }),
            bloodPressure: bloodPressureValidation('notCheckedBloodPressure', {
                checkboxLabel: 'Not Captured',
            }),
            pain: z
                .object({
                notCheckedPain: z.boolean().optional(),
                deniesPain: z.boolean().optional(),
                painLevel: z.string().optional(),
                activity: z.string().optional(),
            })
                .refine((data) => sectionHasValue(data), {
                message: 'Mark as Not Captured if none applies',
                path: [],
            }),
            bowelMovement: z
                .object({
                notCheckedBowelMovement: z.boolean().optional(),
                lastBowelMovement: z.string().optional(),
            })
                .refine((data) => sectionHasValue(data), {
                message: 'Mark as Not Captured if none applies',
                path: [],
            }),
        }),
        Bathing: z.object({
            bathing: z.object({
                requiresBathing: z.boolean().optional(),
                requires: z.string().optional(),
                bathType: z.string().optional(),
                entirety: z.string().optional(),
                safeLevel: z.string().optional(),
            }),
            dressing: z.string().optional(),
            availableEquipment: z.array(z.string()).optional(),
            availableEquipmentOther: z.string().optional(),
        }),
        PersonalCare: z.object({
            personalCare: z.object({
                requiresPersonalCare: z.boolean().optional(),
                requires: z.string().nullish(),
            }),
            hair: z.array(z.string()).optional(),
            teeth: z.array(z.string()).optional(),
            other: z.object({
                other: z.array(z.string()).optional(),
                skinCareSpecify: z.string().nullish(),
                compressionHose: z.boolean().optional(),
            }),
        }),
        Ambulation: z.object({
            ambulation: z.object({
                requiresAmbulation: z.boolean().optional(),
                requires: z.string().optional(),
            }),
            device: z.object({
                devices: z.array(z.string()).optional(),
                other: z.string().nullish(),
            }),
            weightBearing: z.object({
                weightBearing: z.array(z.string()).optional(),
                partialLeg: z.array(z.string()).optional(),
                nonLeg: z.array(z.string()).optional(),
            }),
            requiredAssistance: z.object({
                transfers: z.string().optional(),
                other: z.string().nullish(),
            }),
        }),
        Other: z.object({
            other: z.object({
                otherOptions: z.array(z.string()).optional(),
                catheterDrainage: z.boolean().optional(),
                assistedWithMedications: z.string().optional(),
                ostomyCare: z.string().optional(),
            }),
            rom: z.array(z.string()).optional(),
            prepare: z.array(z.string()).optional(),
            changedBedLinens: z.object({
                frequency: z.array(z.string()).optional(),
                frequencyOther: z.string().nullish(),
            }),
            lastBowelMovement: z.string().optional(),
        }),
        Reported: z.object({
            employeeName: z.string().optional(),
            date: z.string().optional(),
            patientComplaining: z.string().optional(),
            other: z.string().optional(),
        }),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
